module.exports = __webpack_public_path__ + "assets/img/message-b3659a41.png";